/* eslint-disable react/no-danger */
import parse from "html-react-parser";
import { footerCSS } from "../../utils/stylesUtil/footer";
import { topOverlayCSS } from "../../utils/stylesUtil/topOverlay";
import { ab } from "../../public/js/core/abMock";

export const appendHeadFareFinderDT = (props) => {
  const {
    serviceWorker,
    ccde,
    robotic_tag,
    state,
    jsSettingJson,
    state: initialState,
    initial_css: initialCSS,
    appConfig,
    tokens,
    isGoibibo = false,
  } = props || {};

  let cssPath;
  // let jsPath;
  // let imagePath;
  // let minExt;
  let robotMeta = "";
  let topOverlayPath;
  let serverCssPath = "";

  if (appConfig && appConfig.liveMode) {
    cssPath = `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css`;
    topOverlayPath = isGoibibo
      ? `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/topOverlayGI.min.js`
      : `https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/top_overlay.min.js`;
    serverCssPath = "https://jsak.mmtcdn.com/flights/server";
  } else {
    cssPath = "http://localhost:3000/_next/static/css";
    topOverlayPath = isGoibibo
      ? "http://localhost:3000/_next/static/js/topOverlayGI.min.js"
      : "http://localhost:3000/_next/static/js/top_overlay.min.js";
    serverCssPath = "http://localhost:8000/build/server";
  }
  if (robotic_tag) {
    if (initialState?.fareFinder?.monthsData?.length === 0) {
      robotMeta = '<meta name="robots" content="noindex, nofollow">';
    } else if (initialState?.fareFinder?.monthsData?.length > 0) {
      robotMeta = '<meta name="robots" content="index, follow">';
    }
  } else {
    robotMeta = '<meta name="robots" content="index, follow">';
  }

  const tokenJsonString = `var tokenJson = {"dest_city_name":"${tokens.src_city_name}","src_city_code":"${tokens.src_city_code}","dest_city_code":"${tokens.dest_city_name}","src_city_name":"${tokens.dest_city_code}"};`;
  const serviceWorkerString = appConfig.liveMode === true && serviceWorker ? serviceWorker : "";
  return (
    <>
      {parse(robotMeta)}
      <link rel="preconnect" href="//jsak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//cssak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//imgak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//fonts.googleapis.com" crossOrigin />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      {isGoibibo ? (
        <link href={`${cssPath}/dweb-header.min.css`} rel="stylesheet" />
      ) : (
        <link href={`${cssPath}/header.min.css`} rel="stylesheet" />
      )}
      <style dangerouslySetInnerHTML={{ __html: topOverlayCSS }} />
      <link rel="stylesheet" href={`${serverCssPath}${initialCSS}`} />
      <style dangerouslySetInnerHTML={{ __html: footerCSS }} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
        window.urlParams = "?tripType=O&paxType=A-1_C-0_I-0&cabinClass=E&itinerary=${
          tokens.src_city_code
        }-${tokens.dest_city_code}-${tokens.mm_yyyy}&pwa=false${isGoibibo ? "&cmpid=SEO" : "&cmp=SEO"}";
        window.showLeaveIntent = true;
        window._INITIAL_STATE_= ${JSON.stringify(state)};
        window.isPWA = false;
        window.isProduction = 'true';
        window.page = "fare-finder";
        window.countryCode = '${ccde}';
        window.lang = 'eng';
        window.url = 'fare-finder?tripType=O&paxType=A-1_C-0_I-0&cabinClass=E&itinerary=${
          tokens.src_city_code
        }-${tokens.dest_city_code}-${tokens.mm_yyyy}&pwa=false${isGoibibo ? "&cmpid=SEO" : "&cmp=SEO"}';
        window.AB=${JSON.stringify(ab)};
        window.jsSetting = ${JSON.stringify(jsSettingJson)};
        var jsSettingJson = ${JSON.stringify(jsSettingJson)};
        ${tokenJsonString}
      `,
        }}
      />
      <script dangerouslySetInnerHTML={{ __html: `${serviceWorkerString}` }} />
      <script defer type="text/javascript" src={`${topOverlayPath}`} />
    </>
  );
};
